import { render } from "./NameModal.vue?vue&type=template&id=0c0fb43c&scoped=true&ts=true"
import script from "./NameModal.vue?vue&type=script&lang=ts"
export * from "./NameModal.vue?vue&type=script&lang=ts"

import "./NameModal.vue?vue&type=style&index=0&id=0c0fb43c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0fb43c"],['__file',"src/components/NameModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c0fb43c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c0fb43c', __exports__)) {
    api.reload('0c0fb43c', __exports__)
  }
  
  module.hot.accept("./NameModal.vue?vue&type=template&id=0c0fb43c&scoped=true&ts=true", () => {
    api.rerender('0c0fb43c', render)
  })

}


export default __exports__